
import  axios  from 'axios';

export default axios.create({
    baseURL:'https://react-quiz-837b0.firebaseio.com/'
})
